import { useQuery } from '@tanstack/react-query'
import { practiceApi } from '../api/practice.api'

export const GAMES_QUERY_KEY = ['practice', 'games'] as const

/**
 * Mécaniques jouables (SPEC §12, `GET /practice/games`) — déjà filtrées
 * côté serveur selon les items disponibles ET les mécaniques implémentées
 * (`GetPlayableGamesQuery`). `GameCatalog` ne fait qu'afficher cette liste,
 * jamais la recomposer.
 */
export function useGames() {
  return useQuery({
    queryKey: GAMES_QUERY_KEY,
    queryFn: () => practiceApi.fetchGames().then((response) => response.data.data),
    staleTime: 60_000,
  })
}
